<template>
  <div class="over_layout">
    <section class="upgrade">
      <a style="cursor: pointer" @click="$store.commit('paymentModal', true)">{{ $store.getters.t('create_resume') }}</a>
    </section>
    <section class="about_page">
      <div class="wrapper">
        <div class="pages_header">
          <div class="lines">
            <h1>О нас</h1>
          </div>
          <div class="description">
            <h2>{{ data.title }}</h2>
          </div>
        </div>
        <div class="about_page_block">
          <div class="text_area fr-view" v-html="data.content"></div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {}
    };
  },
  mounted() {
    this.$parent.getData().then(changed => {
      if (changed) {
        this.getData();
      }
    });
  },
  watch: {
    $route(to, from) {
      if (to.params.lang != from.params.lang) {
        this.$parent.getData().then(changed => {
          if (changed) {
            this.getData();
          }
        });
      }
    }
  },
  methods: {
    getData() {
      this.$http({
        method: "get",
        url: "/api/about-us"
      }).then(res => {
        if (res.data.translations) {
          this.data = res.data.translations[0];
          document.title = this.data.seo_title;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/about.vue